// @ts-nocheck
import { ReactNode, useState } from "react";
import { Sidebar, MobileMenuButton } from "./Sidebar";
import { Header } from "./Header";
import { cn } from "@libraryadmin/lib/utils";

interface DashboardLayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
}

export function DashboardLayout({
  children,
  title,
  subtitle,
}: DashboardLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="library-admin-module min-h-screen bg-background">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
      <div
        className={cn(
          "transition-all duration-300",
          collapsed ? "lg:pl-[72px]" : "lg:pl-72"
        )}
      >
        <Header
          title={title}
          subtitle={subtitle}
          mobileMenuButton={
            <MobileMenuButton onClick={() => setMobileOpen(true)} />
          }
        />
        <main className="px-2.5 py-4 sm:p-4 md:p-6">{children}</main>
      </div>
    </div>
  );
}
